import { useMemo } from 'react';
import { DateTime } from 'luxon';

import { NoteInsightsViewOptions } from 'modules/Insights/Notes/NoteInsightsContextProvider';
import { Period } from 'graphql/types';

export const useGetPreviousPeriod = ({
  currentPeriod,
  selectedViewOption
}: {
  currentPeriod: Period | null;
  selectedViewOption: NoteInsightsViewOptions;
}): {
  prevStartDate: string;
  prevEndDate: string;
} => {
  const { prevStartDate, prevEndDate } = useMemo(() => {
    const startDate = DateTime.fromISO(currentPeriod?.startDate || '');
    const endDate = DateTime.fromISO(currentPeriod?.endDate || '');
    let prevStartDate = currentPeriod?.startDate || '';
    const prevEndDate = startDate.minus({ days: 1 }).toISODate();

    switch (selectedViewOption) {
      case NoteInsightsViewOptions.THIS_WEEK:
        prevStartDate = startDate.minus({ weeks: 1 }).toISODate();
        break;
      case NoteInsightsViewOptions.THIS_MONTH:
        prevStartDate = startDate
          .minus({ days: 1 })
          .startOf('month')
          .toISODate();
        break;
      default: {
        const noOfDays = endDate.diff(startDate, 'days').days + 1;
        prevStartDate = startDate.minus({ days: noOfDays }).toISODate();
        break;
      }
    }
    return { prevStartDate: prevStartDate, prevEndDate: prevEndDate };
  }, [currentPeriod?.endDate, currentPeriod?.startDate, selectedViewOption]);

  return useMemo(
    () => ({
      prevStartDate,
      prevEndDate
    }),
    [prevEndDate, prevStartDate]
  );
};
